import axios from "axios";
import { useSession } from "next-auth/react";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import { SubmitHandler, useForm, useWatch } from "react-hook-form";
import { useRecoilState, useSetRecoilState } from "recoil";
import { authFormState } from "../../Atoms/auth/AuthFormState";
import { userState } from "../../Atoms/auth/UserAuth";
// import language from '../../helpers/language';
import { useToastHelper } from "@/helpers/helperFunctions";
import {
  Trading_Experience,
  cn,
  countries,
  countries_iso2,
  countryData,
} from "@/lib/utils";
import { ChevronsUpDown, Eye, EyeOff, Loader2 } from "lucide-react";
import { NextPage } from "next";
import { useTranslation } from "next-i18next";
import { LuCheck, LuLoader2 } from "react-icons/lu";
import OTPInput from "react-otp-input";
import { Button } from "../ui/button";

import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../ui/form";
import { Input } from "../ui/input";

import PrivacyPolicy from "@/components/PrivacyPolicy";
import TermsAndConditions from "@/components/TermsAndConditions";
import { Checkbox } from "../ui/checkbox";
import Link from "next/link";
import { CURRENT_BROKER_NAME, CURRENT_SERVER_URL } from "@/config/logos";
import clsx from "clsx";
interface IFormValues {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  phone_number: string;
  country: string;
  trading: string;
  university: string;
  referral: string;
  agreeMarketingCommunications: boolean;
}

const RegisterCard: NextPage = (props: any) => {
  const { toast } = useToastHelper();
  const form = useForm<IFormValues>();
  const values = form.watch();
  const allFieldsFilled = Object.entries(values)
    .filter(([key]) => key !== "referral")
    .every(([, val]) => val !== undefined && val !== null && val !== "");
  const { data: session } = useSession();
  const router = useRouter();
  const ac = useRef<AbortController>();
  const { t } = useTranslation("common");
  const [otpLoading, setOtpLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isReferDisabled, disableRefer] = useState(false);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState<string>("United Kingdom");
  const [resendOtpShow, setResendOtpShow] = useState(false);
  const [countryCode, setCountryCode] = useState<any>(
    countryData?.find((framework) => framework.name == value)?.dial_code || ""
  );
  const [show, setShow] = useState(false);
  const [otp, setOtp] = useState("");
  const togglePasswordVisibility = () => {
    if (showPassword) {
      setShowPassword(false);
    } else {
      setShowPassword(true);
    }
  };
  const sendOtp = async () => {
    setLoading(true);
    let url = new URL("https://hub2.trylevel2.com/send_sms_otp");
    url.searchParams.append("ph_number", "");
    url.searchParams.append("email", form.getValues("email"));
    const response = await axios.post(url.toString());
    if (response?.data?.message) {
      setShow(true);
      toast.success(response.data.message);
      setLoading(false);
    } else {
      toast.error("Error sending OTP.");
      setLoading(false);
    }
  };
  const validSmsOtp = async (otp: any) => {
    setOtpLoading(true);
    let url = new URL("https://hub2.trylevel2.com/validate_sms_otp");
    url.searchParams.append("otp", otp);
    url.searchParams.append("email", form.getValues("email"));
    const res = await axios
      .post(url.toString())
      .catch((d) => {
        if (d?.response?.status === 400) toast.error(d?.response?.data?.detail);
        else toast.error("Error");
      })
      .finally(() => setOtpLoading(false));
    if (res?.data) {
      // check valid otp
      setShow(false);
      toast.success(res?.data?.message);
      try {
        ac.current?.abort?.();
        setLoading(true);
        const response = await axios
          .post(
            `https://hub2.trylevel2.com/register_user?auth=${res?.data.auth}`,
            {
              email: form.getValues("email"),
              password: form.getValues("password"),
              first_name: form.getValues("firstName"),
              last_name: form.getValues("lastName"),
              country: form.getValues("country"),
              trading_experience: form.getValues("trading"),
              phone_number: countryCode + form.getValues("phone_number"),
              referral: form.getValues("referral"),
              trading_challenge: `${CURRENT_BROKER_NAME}.trylevel2.com`,
              source: "create-new-account",
              university: "",
            }
          )
          .catch((err) => {
            if (err?.response?.status === 400 && err?.response?.data?.detail) {
              toast.error(err.response.data.detail);
            } else throw err;
          });
        if (response) {
          router.push(response.data.redirect_url);
          toast.success(
            "Registration successful - Please wait to be redirected to Plus100"
          );
          // }
        }
        setLoading(false);
      } catch (error: any) {
        setOtpLoading(false);
        setLoading(false);
        toast.error(error.message);
      }
    } else toast.error(res?.data?.message || "Error");
  };
  const handleSubmitForm: SubmitHandler<IFormValues> = async (formData) => {
    sendOtp();
  };
  const setAuthHeader = (token: string) => {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  };

  const countrySelectOpt = countries.map((data: any) => {
    return { value: data, label: data };
  });

  const filteredData = countryData.filter((item) =>
    countries_iso2.includes(item.code.toLowerCase())
  );
  useEffect(() => {
    if (router?.query?.referral) {
      form.setValue("referral", router.query.referral as string);
      disableRefer(true);
    }
  }, [session, router]);
  useEffect(() => {
    if (typeof window !== "undefined") {
      form.setValue("agreeMarketingCommunications", true);
      if ("OTPCredential" in window) {
        ac.current = new AbortController();
        navigator.credentials
          .get({
            // @ts-ignore
            otp: { transport: ["sms"] },
            signal: ac.current.signal,
          })
          .then((otp) => {
            // @ts-ignore
            otp.code && setOtp(otp.code);
          })
          .catch((err) => {});
      }
    }
  }, []);
  if (session) {
    //router.push('/build')
    // return (
    //   <div className="">
    //     Welcome user<br />
    //     <button onClick={() => signOut()}>Sign out</button>
    //   </div>
    // );
  }

  const submit = () => {
    setOtp("");
    validSmsOtp(otp);
  };
  const resendTextAppear = () => {
    const interval = setInterval(() => setResendOtpShow(true), 60000);
    return () => {
      clearInterval(interval);
    };
  };
  const resend = () => {
    setResendOtpShow(false);
    sendOtp();
    resendTextAppear();
  };
  return (
    <>
      <Dialog open={show} onOpenChange={(open) => setShow(!show)}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Enter verification code</DialogTitle>
          </DialogHeader>
          <div className="w-full flex justify-center items-center h-full">
            <OTPInput
              value={otp}
              onChange={setOtp}
              shouldAutoFocus
              numInputs={4}
              renderSeparator={<span className="text-transparent">-</span>}
              renderInput={({
                style: { color, background, ...style },
                ...props
              }) => (
                <Input
                  {...props}
                  style={{
                    ...style,
                    color: void 0,
                    backgroundColor: void 0,
                    width: 40,
                  }}
                  autoComplete="off"
                />
              )}
            />
          </div>
          <div className="text-center text-muted-foreground text-sm">
            {t("A verification code has been sent to your email address")}
          </div>
          {resendOtpShow ||
            (true && (
              <div className="text-muted-foreground pt-2 text-center">
                {t("Didn't receive OTP? ")}{" "}
                <span
                  className="underline cursor-pointer"
                  onClick={() => resend()}
                >
                  {t("Resend")}
                </span>
              </div>
            ))}
          <DialogFooter>
            <Button onClick={() => submit()} disabled={loading}>
              {t("Submit")}{" "}
              {otpLoading ? <LuLoader2 className="animate-spin ml-1" /> : ""}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <div className="max-w-[700px] w-full mb-5">
        <Form {...form}>
          <form
            method="post"
            autoComplete="false"
            onSubmit={form.handleSubmit(handleSubmitForm)}
            className="flex flex-col space-y-4 "
          >
            <div className="flex w-full gap-4 ">
              <FormField
                control={form.control}
                name="firstName"
                rules={{ required: t("First name is required") }}
                render={({ field }) => (
                  <FormItem className="w-full">
                    <FormControl>
                      <Input
                        className={cn(
                          "w-full",
                          !field.value && "text-muted-foreground"
                        )}
                        placeholder={t("First name *")}
                        type="text"
                        {...field}
                      />
                    </FormControl>
                    <FormMessage className="text-xs" />
                  </FormItem>
                )}
              />
              <FormField
                control={form.control}
                name="lastName"
                rules={{ required: t("Last name is required") }}
                render={({ field }) => (
                  <FormItem className="w-full">
                    <FormControl>
                      <Input
                        className="w-full"
                        placeholder={t("Last name *")}
                        type="text"
                        {...field}
                      />
                    </FormControl>
                    <FormMessage className="text-xs" />
                  </FormItem>
                )}
              />
            </div>
            <FormField
              control={form.control}
              name="email"
              rules={{
                required: t("Email is required"),
                pattern: {
                  value: /\S+@\S+\.\S+/,
                  message: t("components.loginCard.error.validEmail"),
                },
              }}
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <Input
                      className={"w-full"}
                      placeholder={t("Email *")}
                      type="text"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage className="text-xs" />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="password"
              rules={{ required: t("Password is required") }}
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <div className="relative">
                      <Input
                        placeholder={t("Choose a password *")}
                        type={showPassword ? "text" : "password"}
                        {...field}
                      />
                      <div className="absolute inset-y-0 right-0 pr-3 flex items-center text-muted-foreground cursor-pointer">
                        {showPassword ? (
                          <EyeOff
                            className="h-5 w-5"
                            onClick={togglePasswordVisibility}
                          />
                        ) : (
                          <Eye
                            className="h-5 w-5"
                            onClick={togglePasswordVisibility}
                          />
                        )}
                      </div>
                    </div>
                  </FormControl>
                  <FormMessage className="text-xs" />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="referral"
              disabled={isReferDisabled}
              rules={{
                required: false,
              }}
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <Input
                      className={"w-full"}
                      placeholder={t("Referral code *")}
                      type="text"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage className="text-xs" />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="agreeMarketingCommunications"
              disabled={isReferDisabled}
              rules={{
                required: false,
              }}
              render={({ field }) => (
                <FormItem className="flex flex-row items-start space-x-3 space-y-0">
                  <FormControl>
                    <Checkbox
                      checked={field.value}
                      onCheckedChange={field.onChange}
                      className="scale-75"
                    />
                  </FormControl>
                  <div className="space-y-1 leading-none">
                    <FormDescription className="text-sm">
                      {t("agreeMarketingCommunications")}
                    </FormDescription>
                  </div>
                  <FormMessage className="text-xs" />
                </FormItem>
              )}
            />
            <div className="flex flex-col gap-4 w-full justify-center text-xs text-muted-foreground">
              <div>
                {t("Have an account already?")}{" "}
                <a
                  href={"/"}
                  className="cursor-pointer select-none underline underline-offset-4 hover:text-primary"
                >
                  {t("Sign In")}
                </a>
              </div>
              <div>
                {t("Need tech support? Email us at")}{" "}
                <a
                  href="mailto: support@plus100.ai"
                  className="cursor-pointer select-none underline underline-offset-4 hover:text-primary"
                >
                  support@plus100.ai
                </a>
              </div>
            </div>
            <div className="text-xs text-muted-foreground">
              {t("By creating an account, you acknowledge and accept our")}
              <span className="text-xs text-muted-foreground underline">
                <TermsAndConditions />
              </span>
              {/* <Link href={"https://www.mktdynamics.com/terms-and-conditions"}>
                  <span className="underline cursor-pointer px-1">
                    <span>{t("termsAndConditions")}</span>
                  </span>
                </Link> */}
              {t(" and ")}
              <span className="text-xs text-muted-foreground underline">
                <PrivacyPolicy />
              </span>
              {t(" and ")}
              <Link
                href={`${CURRENT_SERVER_URL}/customer-agreement`}
                className="text-xs text-muted-foreground underline"
              >
                Customer Agreement
              </Link>
            </div>

            <div className="text-center flex justify-center gap-4">
              <Button
                type="submit"
                disabled={loading}
                className={clsx(
                  "gap-2 transition-colors",
                  allFieldsFilled && !loading
                    ? "bg-tl2-blue-base hover:bg-tl2-blue-base"
                    : "bg-[#254285] hover:bg-[#254285] opacity-100   cursor-not-allowed"
                )}
              >
                {t("Sign up")}
                {loading && <Loader2 className="ml-2 h-5 w-5 animate-spin" />}
              </Button>
            </div>
          </form>
        </Form>
      </div>
    </>
  );
};

export default RegisterCard;
